

import { EmploymentStatus, IncomeRange, PurposeOfLoan, Qualification } from "./additional-details-type";

export const DSP_EDUCATION_DATA = [
    {label: 'Up to 12th pass', value: Qualification.UP_TO_12},
    {label: 'Graduate', value: Qualification.UNDER_GRADUATE},
    {label: 'Post graduate or higher', value: Qualification.POST_GRADUATE},
    {label: 'Others', value: Qualification.OTHERS},
];

export const OTHER_EDUCATION_DATA = [
    {label: 'Up to 12', value: Qualification.UP_TO_12},
    {label: 'Diploma', value: Qualification.DIPLOMA},
    {label: 'Graduate', value: Qualification.UNDER_GRADUATE},
    {label: 'Post graduate', value: Qualification.POST_GRADUATE},
    {label: 'MBA', value: Qualification.MBA},
    {label: 'PHD', value: Qualification.PHD},
    {label: 'Professional', value: Qualification.PROFESSIONAL},
    {label: 'Others', value: Qualification.OTHERS},
];


export const DSP_INCOME_RANGE_DATA = [
    {label: 'less than 3 lakhs', value: IncomeRange.ANNUAL_0_3_LAKHS},
    {label: '3 to 10 lakhs', value: IncomeRange.ANNUAL_3_10_LAKHS},
    {label: '10 to 25 lakhs', value: IncomeRange.ANNUAL_10_25_LAKHS},
    {label: 'more than 25 lakhs', value: IncomeRange.ANNUAL_MORE_THAN_25_LAKHS},
];

export const OTHER_INCOME_RANGE_DATA = [
    {label: '3-10 lakhs', value: IncomeRange.ANNUAL_3_10_LAKHS},
    {label: '10-25 lakhs', value: IncomeRange.ANNUAL_10_25_LAKHS},
    {label: 'More than 25 lakhs', value: IncomeRange.ANNUAL_MORE_THAN_25_LAKHS},
];



export const EMPLOYMENT_STATUS_DATA = [
    {label: 'Salaried', value: EmploymentStatus.SALARIED},
    {label: 'Self employed', value: EmploymentStatus.SELF_EMPLOYED},
    {label: 'Business owner', value: EmploymentStatus.BUSINESS_OWNER},
    {label: 'Others', value: EmploymentStatus.OTHERS},
];

export const PROFESSION_DATA = [

];


export const SOURCE_OF_INCOME_DATA = [
        {label: 'Employment', value: 'EMPLOYMENT'},
        {label: 'Self-Employment', value: 'SELF_EMPLOYMENT'},
        {label: 'Investment', value: 'INVESTMENT'},
        {label: 'Rental', value: 'RENTAL'},
        {label: 'Retirement', value: 'RETIREMENT'},
        {label: 'Other (e.g. gifts, inheritances, royalties)', value: 'OTHERS'},
]


export const PURPOSE_OF_LOAN_DATA = [
    {label: 'Wedding', value: PurposeOfLoan.WEDDING},
    {label: 'Home Renovation/Decor', value: PurposeOfLoan.HOME},
    {label: 'Medical or Hospitalisation expenses', value: PurposeOfLoan.MEDICAL_HOSPITALISATION},
    {label: 'Education', value: PurposeOfLoan.EDUCATION},
    {label: 'Holiday/Vacation', value: PurposeOfLoan.HOLIDAY},
    {label: 'Others', value: PurposeOfLoan.OTHERS},
]


// const useOfLoanData = lenderName.toLowerCase() === LENDER_ID.DSP.toLowerCase() ? [
//     {label: 'Personal', value: 'PERSONAL'},
//     {label: 'Business', value: 'BUSINESS'},
//     {label: 'Investments', value: 'INVESTMENT'},
//     {label: 'Emergency', value: 'EMERGENCY'},
// ] : [
//     {label: 'Personal', value: 'PERSONAL'},
//     {label: 'Business', value: 'BUSINESS'},
//     {label: 'Education', value: 'EDUCATION'},
//     {label: 'Travel', value: 'TRAVEL'},
//     {label: 'Medical expenses', value: 'MEDICAL'},
//     {label: 'Investment', value: 'INVESTMENT'},
//     {label: 'Others', value: 'OTHERS'}
// ]

export const PURPOSE_OF_LOAN_DATA_DSP = [
    {label: 'Personal', value: PurposeOfLoan.PERSONAL},
    {label: 'Business', value: PurposeOfLoan.BUSINESS},
    {label: 'Investment', value: PurposeOfLoan.INVESTMENT},
    {label: 'Emergency', value: PurposeOfLoan.EMERGENCY},
]
export const PURPOSE_OF_LOAN_DATA_DSP_V2 = [
    {label: 'Personal', value: PurposeOfLoan.PERSONAL},
    {label: 'Emergency', value: PurposeOfLoan.EMERGENCY},
    {label: 'Business', value: PurposeOfLoan.BUSINESS},
    {label: 'Holiday', value: PurposeOfLoan.HOLIDAY},
    {label: 'Wedding', value: PurposeOfLoan.WEDDING},
    {label: 'Investments in capital markets', value: PurposeOfLoan.INVESTMENTS_IN_CAPITAL_MARKETS},
    {label: 'Other investments', value: PurposeOfLoan.OTHER_INVESTMENTS},
]


export const PURPOSE_OF_LOAN_DATA_TATA = [
    {label: 'Wedding', value: PurposeOfLoan.WEDDING},
    {label: 'Home Renovation/Decor', value: PurposeOfLoan.HOME},
    {label: 'Medical or Hospitalisation expenses', value: PurposeOfLoan.MEDICAL},
    {label: 'Education', value: PurposeOfLoan.EDUCATION},
    {label: 'Holiday/Vacation', value: PurposeOfLoan.HOLIDAY},
    {label: 'Others', value: PurposeOfLoan.OTHERS},
]


export const OCCUPATION_DATA =  [
  {label: 'Student', value: 'STUDENT'},
  {label: 'Salaried', value: 'SALARIED'},
  {label: 'Self Employed', value: 'SELF_EMPLOYED'},
  {label: 'Retired', value: 'RETIRED'}
]